import styled from "styled-components";
import { FIELD_CONTROL_HEIGHT, TITLE_MIN_HEIGHT } from "../constants";

export const Styles = styled.div`
  overflow: auto;
  .ant-form-item {
    margin: 0;
    width: 100%;
  }
  .ant-input,
  .ant-picker,
  .ant-form-item-control-input {
    min-height: ${FIELD_CONTROL_HEIGHT}px;
  }

  .ant-select-selection-overflow {
    min-height: 36px;
  }

  .layout-screen .layout-grid-item.align-to-control > .label_field {
    background: none !important;
    text-align: center;

    transform: translateY(
      calc(
        ${TITLE_MIN_HEIGHT}px +
          var(--field-control-height, ${FIELD_CONTROL_HEIGHT}px) / 2 - 50%
      )
    );

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      margin: 0;
      font-weight: 700;
    }
  }
`;
